/*
 * @Author: Axs <i@axs.email>
 * @Date: 2020-04-24 17:09:42
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2020-08-25 15:35:45
 * @Description: 
 * @FilePath: /src/lib/mint/toast.js
 */
/**
 * 修改 Toast 默认参数
 */
import { Toast } from 'mint-ui';
// 引入时间常量
import { TOAST_STOP_TIME } from '@/lib/constant';

const toast = (...opt) => {
    if ('string' === typeof opt[0]) {
        if(!opt[0]){
            return;
        }
        return Toast({
            message: opt[0],
            duration: opt[1] || TOAST_STOP_TIME
        });
    }
    else {
        if(!opt[0].message){
            return;
        }
        if (!opt[0].duration) {
            opt[0].duration = TOAST_STOP_TIME;
        }
        return Toast(opt[0]);
    }
}
export default toast;